var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 17,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1.70666 1.70666",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_531914968"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531917512",
    d: "m1.47831 1.70663h-1.09847c-.0411929 0-.074689-.0335079-.074689-.0747047v-1.40569c0-.0411772.0335118-.074689.074689-.074689l1.09847-.00000394c.0411772 0 .074689.0335118.074689.074689v1.4057c0 .041185-.0335118.0746929-.074689.0746929zm-1.09847-1.51509c-.019122 0-.0347047.0155709-.0347047.0346929v1.4057c0 .0191378.0155669.0346929.0347047.0346929l1.09847.00000394c.019122 0 .0346811-.0155551.0346811-.0346929v-1.4057c0-.019122-.0155551-.034689-.0346811-.034689l-1.09847-.00000787z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916672",
    d: "m.325138 1.55513h-.0967835c-.0411969 0-.074689-.0335118-.074689-.0747047l-.00000787-1.4057c0-.0411811.0335118-.074689.0746929-.074689h1.09845c.0411969 0 .0747087.0335079.0747087.074689v.0967992c0 .0110394-.00897244.0199961-.02.0199961l-1.00167.00000787c-.019122 0-.0347047.0155669-.0347047.034689v1.30891c0 .0110551-.00894488.0200118-.02.0200118zm-.0967835-1.5151c-.019122 0-.0347087.0155709-.0347087.0346929v1.4057c0 .0191378.0155709.034689.0347087.034689l.0767992.00000787v-1.28889c0-.0411772.0335118-.074689.074689-.074689l.981654-.00000394v-.0767992c0-.019122-.0155512-.0346929-.0346929-.0346929h-1.09845v-.00001575z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916720",
    d: "m.641122.313453h-.194445c-.0110394 0-.02-.00896063-.02-.02 0-.0110394.00896063-.0199961.02-.0199961h.194445c.0110394 0 .02.00895669.02.0199961 0 .0110394-.00894488.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916336",
    d: "m.729843.417764h-.283165c-.0110394 0-.02-.00896063-.02-.02 0-.0110394.00896063-.02.02-.02h.283165c.0110394 0 .02.00896063.02.02 0 .0110394-.00894488.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916888",
    d: "m1.42196.313453h-.194449c-.0110354 0-.0199961-.00896063-.0199961-.02 0-.0110394.0089685-.0199961.0199961-.0199961h.194449c.0110394 0 .02.00895669.02.0199961 0 .0110394-.00896063.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916408",
    d: "m1.42196.417764h-.283185c-.0110354 0-.0199961-.00896063-.0199961-.02 0-.0110394.0089685-.02.0199961-.02h.283185c.0110394 0 .02.00896063.02.02 0 .0110394-.00896063.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916504",
    d: "m1.40131 1.12869h-.941846c-.0110394 0-.02-.0089685-.02-.0199961v-.588575c0-.0110394.00896063-.02.02-.02h.941846c.0110394 0 .02.00896063.02.02v.588575c0 .0110354-.00896063.0199961-.02.0199961zm-.92185-.0400118h.90185v-.548559h-.90185z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916552",
    d: "m1.40131 1.12869h-.24002c-.0110394 0-.02-.0089685-.02-.0199961v-.588575c0-.0110394.00897244-.02.02-.02h.24002c.0110394 0 .02.00896063.02.02v.588575c0 .0110354-.00896063.0199961-.02.0199961zm-.22002-.0400118h.200004v-.548559h-.200004z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916840",
    d: "m1.1613 1.12869h-.250531c-.0110394 0-.0199961-.0089685-.0199961-.0199961v-.588575c0-.0110394.0089685-.02.0199961-.02h.250531c.0110394 0 .02.00896063.02.02v.588575c0 .0110354-.00895669.0199961-.02.0199961zm-.230531-.0400118h.21052v-.548559h-.21052z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531915832",
    d: "m1.40131.685354h-.941846c-.0110394 0-.02-.00896063-.02-.02 0-.0110394.00896063-.02.02-.02h.941846c.0110394 0 .02.00896063.02.02 0 .0110394-.00896063.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916192",
    d: "m.77726.778917h-.232134c-.0110354 0-.0199961-.00895669-.0199961-.0199961 0-.0110394.00896063-.02.0199961-.02h.232134c.0110394 0 .02.00896063.02.02 0 .0110394-.00896063.0199961-.02.0199961z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531915784",
    d: "m.697051.884425h-.151925c-.0110354 0-.0199961-.0089685-.0199961-.0199961 0-.0110394.00896063-.02.0199961-.02h.151909c.0110394 0 .02.00896063.02.02.00001575.0110354-.00893701.0199961-.0199843.0199961z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916096",
    d: "m.644555.989949h-.0994291c-.0110354 0-.0199961-.0089685-.0199961-.02 0-.0110276.00896063-.0199961.0199961-.0199961h.0994291c.0110394 0 .02.0089685.02.0199961 0 .0110315-.00896063.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531915760",
    d: "m1.08533.781358h-.100276c-.0110394 0-.02-.00895669-.02-.0199961 0-.0110394.00897244-.02.02-.02h.100276c.0110394 0 .02.00896063.02.02 0 .0110394-.00896063.0199961-.02.0199961z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531915688",
    d: "m1.08533.884441h-.100276c-.0110394 0-.02-.0089685-.02-.0199961 0-.0110394.00897244-.02.02-.02h.100276c.0110394 0 .02.00896063.02.02.00000787.0110354-.00896063.0199961-.02.0199961z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531916000",
    d: "m1.08533.987535h-.100276c-.0110394 0-.02-.00897244-.02-.02 0-.0110276.00897244-.02.02-.02h.100276c.0110394 0 .02.00897244.02.02 0 .0110276-.00896063.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531915856",
    d: "m1.33296.781358h-.100276c-.0110354 0-.0199961-.00895669-.0199961-.0199961 0-.0110394.0089685-.02.0199961-.02h.100276c.0110394 0 .02.00896063.02.02 0 .0110394-.00896063.0199961-.02.0199961z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531915208",
    d: "m1.33296.884441h-.100276c-.0110354 0-.0199961-.0089685-.0199961-.0199961 0-.0110394.0089685-.02.0199961-.02h.100276c.0110394 0 .02.00896063.02.02.00000787.0110354-.00896063.0199961-.02.0199961z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531914920",
    d: "m1.33296.987535h-.100276c-.0110354 0-.0199961-.00897244-.0199961-.02 0-.0110276.0089685-.02.0199961-.02h.100276c.0110394 0 .02.00897244.02.02 0 .0110276-.00896063.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531915448",
    d: "m.712248 1.21462h-.25278c-.0110394 0-.02-.0089685-.02-.02 0-.0110276.00896063-.0199961.02-.0199961h.25278c.0110394 0 .02.0089685.02.0199961 0 .0110315-.00896063.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531915424",
    d: "m1.41166 1.21462h-.392539c-.0110394 0-.02-.0089685-.02-.02 0-.0110276.00897244-.0199961.02-.0199961h.392551c.0110394 0 .02.0089685.02.0199961 0 .0110315-.00897244.02-.0200118.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531915064",
    d: "m1.41166 1.32217h-.269169c-.0110394 0-.02-.00897244-.02-.02 0-.0110276.00897244-.02.02-.02h.269169c.0110394 0 .02.00897244.02.02 0 .0110276-.00896063.02-.02.02z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_531914800",
    d: "m1.53299 1.59183h-1.20785c-.0110394 0-.02-.00897244-.02-.02v-.14774c0-.0110394.00896063-.02.02-.02l1.20785-.00000787c.0110394 0 .02.00897244.02.02v.147744c.00001181.0110276-.00896063.0200039-.02.0200039zm-1.18785-.0400157h1.16785v-.107732h-1.16785z",
    fill: "rgb(0,0,0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.dba0a54c662437dd8a3326d5936dd823.svg";
export { ForwardRef as ReactComponent };